module.exports = __webpack_public_path__ + "static/media/money_empty.36562fca.png";